import React, { useState } from 'react'

import { Button } from '@material-ui/core'
import { HelpCircle as HelpCircleIcon } from 'react-feather'

import { Container, ContentHeader, Page } from 'components'

import { AuditFormContainer } from '../components'
import { SkeletonForm } from '../components/AuditForm/components'

import useFetch from 'hooks/useFetch'
import * as service from 'service'

const ThirdPartyManagementMySuppliersAuditShow = ({ match }) => {
  const { companySupplierId, companySupplierAuditId } = match.params

  const [openTour, setOpenTour] = useState(false)

  const { response: supplierResponse, refresh } = useFetch(
    service.dponet.suppliers.get,
    { companySupplierId },
  )

  const { response: auditResponse } = useFetch(
    service.dponet.suppliers.audits.show,
    { companySupplierId, companySupplierAuditId },
  )

  const companySupplier = supplierResponse?.data?.companySupplier || null
  const audit = auditResponse?.data?.companySupplierAudit || null
  const isPreAvaliation = companySupplier?.preAvaliation || false

  return (
    <Page title="Gestão de Fornecedores - Visualizar Auditoria">
      <Container maxWidth={false}>
        <ContentHeader title="Visualizar Auditoria">
          <Button
            variant="contained"
            color="primary"
            startIcon={<HelpCircleIcon size={20} />}
            onClick={() => setOpenTour(true)}
          >
            Tutorial
          </Button>
        </ContentHeader>
        {companySupplier && audit ? (
          <AuditFormContainer
            isShow
            companySupplier={companySupplier}
            audit={audit}
            refresh={refresh}
            isPreAvaliation={isPreAvaliation}
            openTour={openTour}
            setOpenTour={setOpenTour}
          />
        ) : (
          <SkeletonForm isShow />
        )}
      </Container>
    </Page>
  )
}

export default ThirdPartyManagementMySuppliersAuditShow
